var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-global-overlay"},[_c('PortalTarget',{directives:[{name:"trap-focus",rawName:"v-trap-focus.loop",value:({
			active: _vm.hasContent,
		}),expression:"{\n\t\t\tactive: hasContent,\n\t\t}",modifiers:{"loop":true}}],ref:"portalTarget",class:[
			'c-global-overlay__target z-50',
			{ 'c-global-overlay__target--active': _vm.hasContent },
		],attrs:{"id":`c-global-overlay-${_vm._uid}`,"multiple":"","name":_vm.name},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }